module.exports = __webpack_public_path__ + "media/images/markers/dropoff-74b2da14fc31a85b437d8d6bd0545603.png";